import {
  AxisIntervalBorderNameType,
  AxisNameType,
  EmissionYAxisType,
} from 'app/components/containers/layout/ConfigTabs/controls/AxisMinMaxInterval/types';
import { PredictionModelsValue } from 'app/components/containers/layout/ConfigTabs/controls/PredictionModels/types';
import { CurveType, EmissionCurvesType, WidgetCurveType } from 'types/Curve';
import { PlanModelType } from 'types/PlanPredictModel';

import { PlanProdCurvesSettingsState } from './types';

const AVAILABLE_PREDICTION_MODELS = [PlanModelType.PLANNED];

export function getInitialState(): PlanProdCurvesSettingsState {
  return {
    curveSelection: {
      [WidgetCurveType.PRODUCTION]: {
        [CurveType.LIQUID]: true,
        [CurveType.GAS]: true,
        [CurveType.WATER]: true,
      },
      [WidgetCurveType.EMISSIONS]: {
        [EmissionCurvesType.CH4CO2E]: true,
        [EmissionCurvesType.CO2]: true,
        [EmissionCurvesType.N2OCO2E]: true,
      },
    },
    cumulativeProduction: true,
    predictionModels: AVAILABLE_PREDICTION_MODELS.reduce(
      (acc, model) => ({
        ...acc,
        [model]: {
          general: true,
          errors: false,
        },
      }),
      {} as PredictionModelsValue,
    ),
    axis: {
      [AxisNameType.X]: {
        [AxisIntervalBorderNameType.MIN]: null,
        [AxisIntervalBorderNameType.MAX]: null,
      },
      [AxisNameType.Y]: {
        [AxisIntervalBorderNameType.MIN]: null,
        [AxisIntervalBorderNameType.MAX]: null,
      },
    },
    emissionAxis: {
      [EmissionYAxisType.CH4_CO2]: {
        [AxisIntervalBorderNameType.MIN]: null,
        [AxisIntervalBorderNameType.MAX]: null,
      },
      [EmissionYAxisType.N2O]: {
        [AxisIntervalBorderNameType.MIN]: null,
        [AxisIntervalBorderNameType.MAX]: null,
      },
    },
    labels: true,
    gridlines: true,
    timeSelection: true,
    aggregateProduction: false,
  };
}
